import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Nav from '../../components/Nav/Nav'
import PlansScreen from '../../components/PlansScreen/PlansScreen'
import { selectUser } from '../../features/userSlice'
import { auth, db } from '../../firebase'
import './ProfileScreen.css'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getCurrentUser } from '../../features/currentUser'
import { Switch } from '@mui/material'
import { connectpaypaltouser, doEmailVerification, getCurrentBalanceOfUser, getCurrentUserData, updateSensitive } from '../../services/f'
import { ColorRing, Oval } from 'react-loader-spinner'
import PaypalCheckoutButton from '../../components/PaypalCheckoutButton/PaypalCheckoutButton'
import { PiUserCircleLight } from 'react-icons/pi'
import Footer from '../../components/Footer'
import VerifyEmailComponent from '../../components/rememberverifyemail'
import { Helmet } from 'react-helmet'
import { loadStripe } from '@stripe/stripe-js';
import {
    PaymentElement,
    Elements,
    useStripe,
    useElements,
    ElementsConsumer,
} from '@stripe/react-stripe-js';
import SaveCardForm from './StripeFolder/SaveCardForm'
import { collection, doc, getDoc, updateDoc } from 'firebase/firestore'
import { stripePromise } from '../../App'
import PayElementStripePremsi from './StripeFolder/PayElementStripePremsi'
import PayWithSavedCards from './StripeFolder/PayWithSavedCards'

const InjectedSaveCardForm = () => (
    <ElementsConsumer>
        {({ stripe, elements, stripeuser }) => (
            <SaveCardForm stripe={stripe} elements={elements} />
        )}
    </ElementsConsumer>
);

const InjectedPayWithSavedCard = ({ amount }) => (
    <ElementsConsumer>
        {({ stripe, elements, stripeuser }) => (
            <PayWithSavedCards stripe={stripe} elements={elements} amount={amount} />
        )}
    </ElementsConsumer>
);

const delay = ms => new Promise(res => setTimeout(res, ms));

function ProfileScreen() {
    let currentUser = useSelector(getCurrentUser).currentUser?.currentUser// ALSO WENNS n user gibt dann wird anderes screen angezeigt
    const dispatch = useDispatch()

    //console.log("this is currentusr", currentUser)
    const [sensitive, setsensitive] = useState(currentUser === null || currentUser === undefined ? false : currentUser?.sensitive);
    const [emailverrequested, setemailverrequested] = useState(false);
    const [balance, setbalance] = useState(-1);
    const [searchParams, setSearchParams] = useSearchParams();
    const [showpaypalpopup, setshowpaypalpopup] = useState(true);
    const [fundaccountshowmore, setfundaccountshowmore] = useState(false);
    const [connectingpp, setconnectingpp] = useState(false);
    const [connectingdone, setconnectingdone] = useState(false);
    const [connectingerror, setconnectingerror] = useState(false);
    const [connecterrornotverified, setconnecterrornotverified] = useState(false);

    const [copiedreferral, setcopiedreferral] = useState(false);
    const [copiedown, setcopiedown] = useState(false);
    const [copiedsecown, setcopiedsecown] = useState(false);
    const [addpaymentmethodshowmore, setaddpaymentmethodshowmore] = useState(false);

    const [paymentsuccess, setpaymentsuccess] = useState(false);
    const [paymentverifying, setpaymentverifying] = useState(false);

    const [fundacc, setfundacc] = useState(false);
    const [fundamount, setfundamount] = useState(0);
    const [paymenttype, setpaymenttype] = useState(0);

    const stripe = useStripe()

    const user = useSelector(selectUser)
    const navigate = useNavigate()

    const product = {
        description: "Fund Account - Premsi - Digital Good funded immediately",
        price: fundamount,
        category: "DIGITAL_GOODS"
    }

    useEffect(() => {
        setsensitive(currentUser?.sensitive)
    }, [currentUser]);

    useEffect(() => {
        // to check if got sth back from stripe payment and now verify it
        const f = async () => {
            let piclientsecret = searchParams.get("payment_intent_client_secret")
            let docid = searchParams.get("docid")
            console.log("useefect for clientsecret", piclientsecret, docid)

            if (piclientsecret === null || piclientsecret === undefined || piclientsecret === "") {
                console.log("nothing", piclientsecret, docid)
                return
            } else {
                console.log("exists so", docid, piclientsecret)
                const { paymentIntent } = await stripe.retrievePaymentIntent(piclientsecret);
                console.log("paymentintent", paymentIntent, docid)

                if (paymentIntent && paymentIntent.status === 'requires_confirmation') {
                    console.log("paymentintent", paymentIntent)
                    //here add paymentintent to object
                    console.log("thos is payment in handleCardAction", paymentIntent)
                    const Ref = doc(db, 'stripe_customers', auth.currentUser.uid, "payments", docid);
                    let payment = paymentIntent
                    await updateDoc(Ref, {
                        status: payment.status
                    })
                    setpaymentverifying(true)
                    await delay(10000)
                    verifying()
                } else if (paymentIntent && paymentIntent.status === 'succeeded') {
                    console.log("paymentintent", paymentIntent)
                    setpaymentsuccess(true)
                    setpaymentverifying(false)
                    await delay(5000)
                    window.location.href = "https://www.premsi.com/profile"
                }
            }
        }
        f()
    }, []);

    useEffect(() => {
        //console.log("page profile reloaded")
        window.paypal.use(['login'], function (login) {
            login.render({
                "appid": process.env.REACT_APP_PAYPAL_CLIENT_ID,
                "authend": "live",
                "scopes": "profile email https://uri.paypal.com/services/paypalattributes",
                "containerid": "paypal-button",
                "responseType": "code",
                "locale": "en-us",
                "buttonType": "CWP",
                "buttonShape": "rectangle",
                "buttonSize": "md",
                "fullPage": "true",
                "returnurl": "https://www.premsi.com/profile"
            })
        });
    });

    const verifying = async () => {
        let piclientsecret = searchParams.get("payment_intent_client_secret")
        let docid = searchParams.get("docid")
        console.log("useefect for clientsecret", piclientsecret, docid)

        if (piclientsecret === null || piclientsecret === undefined || piclientsecret === "") {
            console.log("nothing", piclientsecret, docid)
            return
        } else {
            console.log("exists so", docid, piclientsecret)
            const { paymentIntent } = await stripe.retrievePaymentIntent(piclientsecret);
            console.log("paymentintent", paymentIntent, docid)

            if (paymentIntent && paymentIntent.status === 'requires_confirmation') {
                console.log("paymentintent", paymentIntent)
                //here add paymentintent to object
                console.log("thos is payment in handleCardAction", paymentIntent)
                const Ref = doc(db, 'stripe_customers', auth.currentUser.uid, "payments", docid);
                let payment = paymentIntent
                await updateDoc(Ref, {
                    status: payment.status
                })
                setpaymentverifying(true)
                await delay(10000)
                verifying()
                // Handle successful payment here
            } else if (paymentIntent && paymentIntent.status === 'succeeded') {
                // Handle unsuccessful, processing, or canceled payments and API errors here
                console.log("paymentintent", paymentIntent)
                setpaymentsuccess(true)
                setpaymentverifying(false)
                await delay(5000)
                window.location.href = "https://www.premsi.com/profile"

            } else {

            }
        }

    }

    useEffect(() => {
        const code = searchParams.get("code");
        const hasCode = code !== null && code !== "" && code !== undefined;
        if (hasCode) {
            setshowpaypalpopup(false);
        } else {
            setshowpaypalpopup(true);
        }
    }, [searchParams]);

    const changesensitive = (e) => {
        e.preventDefault()
        if (!sensitive !== currentUser?.sensitive && currentUser?.sensitive !== null) {
            //console.log("change sensitive for user")
            updateSensitive(auth.currentUser.uid, !currentUser?.sensitive).then(() => {
                //console.log("done changing")
                dispatch(getCurrentUserData())
            })
        }
        setsensitive(!sensitive)
    }

    const getCurrentBalance = (e) => {
        e.preventDefault()
        //console.log("get current balance")
        getCurrentBalanceOfUser().then((res) => {
            //console.log(res)
            setbalance(res.balance)
        })
    }

    const verifyemail = (e) => {
        e.preventDefault()
        if (emailverrequested === false && (currentUser?.emailversent === undefined || currentUser.emailversent === 0 || currentUser.emailversent === null || ((currentUser.emailversent.seconds + 86400) * 1000) <= new Date())) {
            doEmailVerification().then(() => setemailverrequested(true))
        } else {
            setemailverrequested(true)
        }
    }

    const connectpaypal = (e) => {
        e.preventDefault()
        //console.log("starting connecting")
        setconnectingpp(true)
        connectpaypaltouser(searchParams.get("code")).then((res) => {
            //console.log("done connecting", res)
            if (res === "success") {
                setconnectingpp(false)
                setconnectingdone(true)
            } else if (res === "errorverified") {
                setconnectingpp(false)
                setconnecterrornotverified(true)
            } else {
                setconnectingpp(false)
                setconnectingerror(true)
            }
        })
    }
    let titledescription = "Hi " + currentUser?.displayName + ", here you can edit your profile." + "Sell and market digital content in seconds. Download the Premsi App for more features. Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute."
    let titlet = "Premsi - Your profile: " + currentUser?.displayName
    const hasBanner = currentUser && currentUser.bannerBgImage !== "" && currentUser.bannerBgImage != null && currentUser.bannerBgImage !== undefined

    return (
        <div className="profile-page__wrap profilescreen">
            <Helmet>
                {/* Open Graph Meta Tags */}
                <meta property="og:title" content="Premsi | Profile - Sell and market digital content in seconds" />
                <meta property="og:description" content="Premsi | Sell and market digital content in seconds. Download the Premsi App for more features. Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
                <meta property="og:url" content="https://premsi.com/profile" />
                <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
                <meta property="og:site_name" content="Premsi - sell digital content" />
                <link rel="canonical" href="https://premsi.com/profile" />

                <title>{titlet}</title>
                <meta name="description" content={titledescription} />
            </Helmet>
            <Nav />
            {auth.currentUser === null || auth.currentUser === undefined || auth?.currentUser?.emailVerified === true ? null : <VerifyEmailComponent />}

            {paymentsuccess && (
                <div className="profile-page__alert profile-page__alert--success">
                    <p className="profile-page__alert-text">Payment Verified!</p>
                </div>
            )}

            {paymentverifying && (
                <div className="profile-page__alert profile-page__alert--success">
                    <p className="profile-page__alert-text">Payment being verified now!</p>
                </div>
            )}

            <div className="profile-page profilebody">
                <div className="profile-page__card profilescreen__body">
                    <div className="profile-page__hero topbannerprofile">
                        {hasBanner && (
                            <img loading="lazy" className="profile-page__hero-banner avatar_profilebanner" src={currentUser?.bannerBgImage} alt="Premsi user pic" />
                        )}
                        <div className={`profile-page__avatar avatar_nopic_profile_div ${hasBanner ? "profile-page__avatar--with-banner" : "profile-page__avatar--no-banner"} ${(currentUser?.photoUrl === "" || currentUser?.photoUrl == null || currentUser === undefined) ? "profile-page__avatar--fallback" : ""}`}>
                            {currentUser?.photoUrl === "" || currentUser === null || currentUser === undefined ? (
                                <PiUserCircleLight className="profile-page__avatar-fallback avatar_nopic_profile" size={50} color="#009ffd" alt="no profile picture" />
                            ) : (
                                <img loading="lazy" className="profile-page__avatar-img avatar_profileprofile" src={currentUser?.photoUrl} alt="Premsi user pic" />
                            )}
                        </div>
                    </div>

                    <div className="profile-page__header profiletop">
                        <h1 className="profile-page__title editprofileheading" onClick={() => navigate("/user?id=" + auth.currentUser.uid)}>{currentUser?.displayName}</h1>
                        <div className="profile-page__actions">
                            <button type="button" className="profile-page__btn profile-page__btn--primary" onClick={() => (navigator.clipboard.writeText(`https://premsi.com/user?id=${currentUser?.displayName}`), setcopiedown(true))}>
                                {copiedown ? "Copied 🎉" : "Share your Profile 🎉"}
                            </button>
                            <button type="button" className="profile-page__btn profile-page__btn--primary" onClick={() => (navigator.clipboard.writeText(`https://premsi.com/user?id=${currentUser?.displayName}&t=p`), setcopiedsecown(true))}>
                                {copiedsecown ? "Copied 🎉" : "Share your Premium Messages 🎉"}
                            </button>
                            <button type="button" className="profile-page__btn profile-page__btn--secondary" onClick={() => navigate("/createpremiummessage")}>
                                Sell with Premsi 💰
                            </button>
                        </div>
                    </div>

                    <div className="profile-page__content profilescreen__info">
                        <div className="profile-page__details profilescreen__details">
                            <button type="button" className="profile-page__cta changeinfoinapp" onClick={() => navigate("/app")}>To change more information please download our App.</button>
                            <div className="profile-page__email emaildiv">
                                <p className="profile-page__email-text profileemail">{user.email}</p>
                                {auth.currentUser.emailVerified === false && (
                                    <button type="button" className="profile-page__btn profile-page__btn--danger" onClick={verifyemail}>
                                        {emailverrequested ? "E-Mail sent!" : "Verify your e-mail!"}
                                    </button>
                                )}
                            </div>

                            {currentUser === undefined ? (
                                <div className="profile-page__loading">
                                    <div className="profile-page__loading-spinner">
                                        <Oval height={40} width={40} color="#009FFD" wrapperClass="" visible={true} ariaLabel="oval-loading" secondaryColor="white" strokeWidth={5} strokeWidthSecondary={5} />
                                    </div>
                                    <p className="profile-page__loading-text">Refreshing user...</p>
                                    <p className="profile-page__loading-hint">If this takes too long please refresh this window.</p>
                                </div>
                            ) : (
                                <>
                                    {/*<div className={!fundaccountshowmore ? "fundingrowoff" : "fundingrowon"}>
                                    <div className='inrow'>
                                        <div style={{ cursor: "pointer", flex: 1, alignItems: "center" }}>
                                            <h3>Fund Account</h3>
                                            {!fundacc ? null : <p style={{ color: "red", fontSize: 12 }}>Min. funding amount is 1$.</p>}
                                        </div>
                                        <div className='fundingbtns' style={{ display: "grid", alignItems: "center", justifyContent: "center" }}>
                                            <button onClick={getCurrentBalance} style={{ cursor: "pointer", color: "darkgreen", paddingLeft: 10, paddingRight: 10, fontWeight: "bold", border: "0", borderRadius: 15, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "lightgreen", height: 30 }}>
                                                <p style={{ fontSize: 12, color: "darkgreen" }}>Get current balance {balance === -1 ? null : `${balance}$`}</p>
                                            </button>
                                            {fundaccountshowmore
                                                ?
                                                <button style={{ marginTop: 15, right: 0, height: 30, paddingLeft: 10, paddingRight: 10, border: "0", borderRadius: 15, color: "white", backgroundColor: "gray", fontWeight: "bold" }} onClick={() => (setfundamount(0), setfundaccountshowmore(false))}>Close</button>
                                                :
                                                <button style={{ marginTop: 15, height: 30, paddingLeft: 10, paddingRight: 10, border: "0", borderRadius: 15, color: "white", backgroundColor: "#009FFD", fontWeight: "bold" }} onClick={() => setfundaccountshowmore(true)}>Fund Account</button>
                                            }
                                        </div>
                                    </div>

                                    {fundaccountshowmore
                                        ?
                                        ((Number(currentUser?.createdAt.seconds) + (5 * 60)) > (Math.floor(new Date().getTime() / 1000)) || currentUser === undefined
                                            ?
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <p style={{ textAlign: "center", width: "90%", fontSize: 14, color: "red" }}> Your Account needs to be atleast 5 minutes old in order to be able to fund it with money.</p>
                                            </div>
                                            :
                                            <div className={fundaccountshowmore ? 'fadeIn' : 'fadeout'}>
                                                <p style={{ textAlign: "center" }}>Please select an amount min. 5$</p>
                                                <div style={{ display: "flex", marginTop: 10, marginBottom: 10, alignItems: "center", justifyContent: "center" }}>
                                                    <input style={{ borderStyle: "solid", borderColor: "#009ffd", color: "black", fontSize: 17, borderRadius: 10, height: 30, textAlign: "center", width: 100, backgroundColor: "rgba(255,255,255,0.4)" }} onChange={(e) => setfundamount(Number(e.target.value))} type="number" placeholder='$' />
                                                </div>
                                                {fundamount < 5
                                                    ?
                                                    <p style={{ textAlign: "center", color: "red", fontSize: 14, marginBottom: 10 }}>Please input atleast 5$.</p>
                                                    :
                                                    <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
                                                        <div onClick={() => setpaymenttype(1)} style={{ width: 120, height: 30, borderRadius: 15, backgroundColor: "#009ffd", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                            PayPal
                                                        </div>
                                                        <div onClick={() => setpaymenttype(3)} style={{ width: 120, height: 30, borderRadius: 15, backgroundColor: "#009ffd", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                            Saved Cards
                                                        </div>
                                                        <div onClick={() => setpaymenttype(2)} style={{ width: 120, height: 30, borderRadius: 15, backgroundColor: "#009ffd", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                            Credit Card
                                                        </div>
                                                    </div>
                                                }
                                                {paymenttype === 0 ?
                                                    null :
                                                    (paymenttype === 1
                                                        ?
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                            <div className='paypal-button-container' style={{ marginTop: 15, width: "60%" }}>
                                                                <PaypalCheckoutButton product={product} price={fundamount} />
                                                            </div>
                                                        </div>
                                                        :
                                                        (paymenttype === 2
                                                            ?
                                                            <div style={{ marginTop: 15 }}>
                                                                <Elements stripe={stripePromise} options={{ mode: "payment", amount: fundamount, currency: "usd" }}>
                                                                    <PayElementStripePremsi amount={fundamount} />
                                                                </Elements>
                                                            </div>
                                                            :
                                                            <InjectedPayWithSavedCard amount={fundamount} />)
                                                    )
                                                }
                                            </div>)
                                        :
                                        null
                                    }
                                </div>*/}

                                    <div className={!addpaymentmethodshowmore ? "fundingrowoff" : "fundingrowon profile-page__row-wrap"}>
                                        <div className="profile-page__row inrow">
                                            <div className="profile-page__row-head">
                                                <h3 className="profile-page__row-title">Add Payment Method</h3>
                                                <p className="profile-page__row-desc">for faster checkout</p>
                                            </div>
                                            <div className="profile-page__row-actions fundingbtns">
                                                {addpaymentmethodshowmore ? (
                                                    <button type="button" className="profile-page__btn profile-page__btn--secondary" onClick={() => setaddpaymentmethodshowmore(false)}>Close</button>
                                                ) : (
                                                    <button type="button" className="profile-page__btn profile-page__btn--primary" onClick={() => setaddpaymentmethodshowmore(true)}>Add Card</button>
                                                )}
                                            </div>
                                        </div>
                                        {addpaymentmethodshowmore && <InjectedSaveCardForm />}
                                    </div>

                                    <div className="profile-page__row inrow">
                                        <div className="profile-page__row-head">
                                            <h3 className="profile-page__row-title">Sensitive</h3>
                                            <p className="profile-page__row-desc">{sensitive ? "You can see sensitive content" : "You don't see sensitive content."}</p>
                                        </div>
                                        {currentUser?.settedsensitive !== undefined && (Number(currentUser?.settedsensitive?.seconds) + (60 * 60 * 24)) > (Math.floor(new Date().getTime() / 1000)) ? (
                                            <p className="profile-page__row-note senstextbtn">Possible to change only once per day</p>
                                        ) : (
                                            <div className="profile-page__row-switch senstextbtn">
                                                <Switch size="big" color="success" checked={sensitive} onChange={changesensitive} />
                                            </div>
                                        )}
                                    </div>

                                    <div className="profile-page__row inrow">
                                        <div className="profile-page__row-head">
                                            <h3 className="profile-page__row-title">Create a premium message:</h3>
                                            <p className="profile-page__row-desc">Easily market and sell premium pdfs, pictures and videos through Premsi.</p>
                                            <p className="profile-page__row-desc">Download our App to easily create them.</p>
                                        </div>
                                        <button type="button" className="profile-page__btn profile-page__btn--primary copyrefer" onClick={() => navigate("/app")}>Download App</button>
                                    </div>

                                    <div className="profile-page__row inrow">
                                        <div className="profile-page__row-head">
                                            <h3 className="profile-page__row-title">Your Referral code:</h3>
                                            <p className="profile-page__row-desc">Make money by referring new Premsi Users.</p>
                                            <p className="profile-page__row-desc">Currently: 5% for life on Premsi+ Subscription and purchase of premium content.</p>
                                        </div>
                                        <button type="button" className="profile-page__btn profile-page__btn--primary copyrefer" onClick={() => (setcopiedreferral(true), navigator.clipboard.writeText(`https://premsi.com/?referral=${currentUser?.displayName}`))}>
                                            {copiedreferral ? "Copied 🎉" : "Copy my code 🎉"}
                                        </button>
                                    </div>

                                    <div className="profile-page__row inrow">
                                        <div className="profile-page__row-head">
                                            <h3 className="profile-page__row-title">Connect Paypal:</h3>
                                            <p className="profile-page__row-desc pptext">This needs to be done to payout your earnings.</p>
                                            {currentUser?.paypalconnected && <p className="profile-page__row-desc">{currentUser?.paypalemail}</p>}
                                            {currentUser?.paypalconnected && <p className="profile-page__row-desc">To change please connect again your paypal.</p>}
                                        </div>
                                        {!currentUser?.paypalconnected ? (
                                            <span id="paypal-button"></span>
                                        ) : (
                                            <div className="profile-page__paypal-status">
                                                <span className="profile-page__paypal-badge">Connected</span>
                                                {(currentUser?.managedaccount === false || currentUser?.managedaccount === undefined) && <span id="paypal-button"></span>}
                                            </div>
                                        )}
                                    </div>

                                    <div className="profile-page__plans profilescreen__plans">
                                        <h3 className="profile-page__plans-title">Plans</h3>
                                        <PlansScreen />
                                    </div>
                                </>
                            )}

                            <button type="button" onClick={() => (auth.signOut(), navigate("/"))} className="profile-page__signout profilescreen__signout">Sign Out</button>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            {!showpaypalpopup && (
                <div className="profile-page__overlay">
                    <div className="profile-page__overlay-inner">
                        <div className="profile-page__popup paypalconnect_popup">
                            <h2 className="profile-page__popup-title">Connect Paypal?</h2>
                            <p className="profile-page__popup-text">You are about to connect your paypal account to your Premsi account.</p>
                            <p className="profile-page__popup-text">Make sure you have a verified paypal account with a verified e-mail.</p>
                            <p className="profile-page__popup-text">This is needed in order to create payouts.</p>
                            <div className="profile-page__popup-actions">
                                {!connecterrornotverified ? (
                                    !connectingerror ? (
                                        !connectingdone ? (
                                            !connectingpp ? (
                                                <button type="button" className="profile-page__btn profile-page__btn--success" onClick={connectpaypal}>Connect Now</button>
                                            ) : (
                                                <ColorRing visible={true} height="80" width="80" ariaLabel="blocks-loading" wrapperClass="profile-page__popup-spinner" colors={['#009FFD', 'white', '#009FFD', 'white', '#009FFD']} />
                                            )
                                        ) : (
                                            <button type="button" className="profile-page__btn profile-page__btn--success" onClick={() => (dispatch(getCurrentUserData()), setshowpaypalpopup(true))}>Done! Go Back.</button>
                                        )
                                    ) : (
                                        <button type="button" className="profile-page__btn profile-page__btn--danger" onClick={() => (setshowpaypalpopup(true), navigate("/profile"))}>There was an error! Retry.</button>
                                    )
                                ) : (
                                    <button type="button" className="profile-page__btn profile-page__btn--danger" onClick={() => (setshowpaypalpopup(true), navigate("/profile"))}>Your Paypal is not verified! Retry</button>
                                )}
                                {connecterrornotverified && <p className="profile-page__popup-hint">Verify your Paypal by adding a bank account, an e-mail and a phone number!</p>}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ProfileScreen